import debug from "src/modules/debug-logger";
import { CACHE_NAME } from "src/modules/activity-log/constants";

export default async function cacheResponse(response) {
  try {
    const cache = await caches.open(CACHE_NAME);
    await cache.put(response.url, response);
  } catch (error) {
    debug.activityLog("Caching failed", error);
  }
}
